import styled, { css, keyframes } from "styled-components";

export const paddingAdPreview = 15;

export const RightSlideAnimation = {
  initial: { y: "1%", opacity: 0 },
  animate: { y: "0%", opacity: 1 },
  exit: { y: "1%", opacity: 0 },
  transition: { type: "spring", stiffness: 300, damping: 30 },
  style: { width: "inherit", height: "inherit", position: "absolute" }
};

export const SlideUpAnimation = {
  initial: { y: "50%", opacity: 0 },
  animate: { y: "0%", opacity: 1 },
  exit: { y: "50%", opacity: 0 },
  transition: { type: "spring", stiffness: 300, damping: 30 },
  style: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    position: "absolute",
    opacity: 1
  }
};

export const CounterAnimation = {
  initial: { y: "-100%" },
  animate: { y: "0%" },
  exit: { y: "100%", marginTop: "5px" },
  transition: { duration: 0.4, ease: "easeInOut" },
  style: {
    position: "absolute",
    top: "2px",
    left: "2px",
    textAlign: "center"
  }
};

const bblFadInOut = keyframes`
  0%, 80%, 100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  &,
  &::before,
  &::after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: ${bblFadInOut} 1.8s infinite ease-in-out;
  }

  & {
    color: var(--primary-blue);
    font-size: 7px;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
  }

  &::before {
    left: -3.5em;
    animation-delay: -0.32s;
  }

  &::after {
    left: 3.5em;
  }
`;

export const ScaleTemplateAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.5 },
  style: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
};

export const FlexWrapper = styled.div`
  display: flex;
  gap: ${({ gap }) => gap || 0}px;
  flex-direction: ${({ direction }) => direction || "row"};
  flex-wrap: ${({ wrap }) => wrap || "nowrap"};
  justify-content: ${({ justify }) => justify || "center"};
  align-items: ${({ align }) => align || "center"};
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
`;

export const PreviewText = styled.span`
  color: ${({ color }) => color || "#000"};
  font-size: ${({ fontSize }) => fontSize || "var(--fs-xs)"};
  font-style: ${({ fontStyle }) => fontStyle || "normal"};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  line-height: ${({ lineHeight }) => lineHeight || "normal"};
`;

export const StreamTextContainer = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  max-height: calc(var(--lh-base) * 2);

  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-dark-600);
`;

export const MainTemplateWrapper = styled.div`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainTemplateWrapperWithLogo = styled.div`
  max-width: ${({ width }) => width + paddingAdPreview * 2}px;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: ${({ theme }) => `0px 0px 13.269px 0px ${theme.colors.adAssistant.previewBoxShadow}`};
  border-radius: 10px;
  margin-top: 20px;
  padding: ${paddingAdPreview}px;
  gap: ${({ gap }) => gap || 10}px;
`;

export const Header = styled.section`
  display: flex;
  justify-content: center;
  height: 45px;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 12px 12px 12px 20px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.adAssistant.previewBorderColor}`};
`;

export const AdAssistantLayout = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: #eff1fc;
`;

export const AssistantHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 37px;
  width: 100%;
  padding: 10px 0;
  background-color: #fff;
  padding-inline: 40px;

  @media screen and (width < 960px) {
    gap: 6px;
  }

  @media screen and (min-width: 2560px) {
    padding-inline: 320px;
  }
`;

export const HeaderDivider = styled.div`
  width: 1px;
  height: 27px;
  background-color: var(--primary-dark-500);
  ${({ ml }) => {
    return css`
      margin-left: ${ml};

      @media screen and (width < 1200px) {
        margin-left: 0;
      }
    `;
  }};
`;

export const AdAssistantBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 730px;
  gap: 60px;
  margin: 2% auto;
  padding: 0 20px 20px;

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 0;
  }
`;

export const PreviewWrapper = styled.div`
  width: 340px;
  height: 550px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 5px;

  border-radius: 5px;
  border: ${({ theme }) => `1px solid ${theme.colors.adAssistant.previewBorderColor}`};
  background: ${({ theme }) => `${theme.colors.adAssistant.previewBgColor}`};

  @media screen and (min-width: 1440px) {
    width: 390px;
    height: 650px;
  }

  @media screen and (min-width: 1920px) {
    width: 420px;
    height: 700px;
  }

  @media screen and (min-width: 2560px) {
    width: 490px;
    height: 790px;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: ${({ minHeight }) => minHeight || "auto"};
  justify-content: ${({ justify }) => justify || "center"};
  align-items: ${({ align }) => align || "normal"};
  gap: ${({ gap }) => gap || 0}px;
`;

export const UseDismissWrapper = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 89px;
  width: 100%;
  gap: 17px;
`;

export const DismissButon = styled.button`
  display: flex;
  width: 110px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 3px;
  border: none;
  height: 33px;

  background-color: var(--primary-red-300, #ff7a61);
  color: var(--primary-white);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: 600;

  cursor: pointer;

  ${({ $isUsed }) =>
    $isUsed &&
    css`
      background-color: var(--primary-dark-100);
      color: var(--primary-blue);
      border: 1px solid var(--primary-dark-200);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
      background-color: var(--primary-grey-500);
      color: var(--primary-white);
      pointer-events: none;
    `}

  @media screen and (min-width: 1920px) {
    height: 42px;
  }
`;

export const UseButton = styled.button`
  display: flex;
  width: 110px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 3px;
  border: none;
  height: 33px;

  background: var(--primary-green);
  color: var(--primary-black);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: 600;

  cursor: pointer;

  ${({ $isUsed }) =>
    $isUsed &&
    css`
      background-color: var(--primary-dark-100);
      color: var(--primary-black);
      border: none;
      width: fit-content;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
      background-color: var(--primary-grey-500);
      color: var(--primary-white);
      pointer-events: none;
    `}

  @media screen and (min-width: 1920px) {
    height: 42px;
  }
`;

export const RandomizeButton = styled.button`
  cursor: pointer;
  width: fit-content;
  border-radius: 5px;
  display: inline-flex;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  font-size: var(--fs-base);
  line-height: var(--ls-base);
  color: var(--primary-blue);
  background-color: var(--primary-dark-100);
  border: 1px solid var(--primary-dark-200);

  &:hover {
    transform: scale(1.05);
  }
`;

export const EditionLayer = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
`;

export const EditionContainer = styled.div`
  position: relative;

  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content; // this allows the items to be the exact same width of the longest item.
  place-content: center;
  gap: 5px;
  width: 100%;
  height: 100%;
  background: rgba(30, 34, 255, 0.6);
`;

export const EditionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  position: relative;

  cursor: pointer;
  white-space: nowrap;
  padding: 6px 10px;
  height: 29px;
  min-width: 89px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 80px rgba(0, 0, 0, 0.15);
  z-index: 1;
  transition: background-color 0.3s ease;

  font-family: Rubik;
  font-weight: 500;
  font-style: normal;
  font-size: var(--fs-base);
  border: 1px solid var(--primary-white);
  color: var(--primary-white);

  &:hover {
    background-color: ${({ hoverColor }) => hoverColor || "var(--primary-grey-500)"};
  }

  > svg {
    flex-shrink: 0;
  }

  /* Click effect */
  &:active {
    transform: scale(0.98);
  }
`;

export const AdDraftContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 12px;
  align-items: center;
`;

export const AdDraftNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  padding: 2px;
  padding-right: 7px;
  border-radius: 3px;
  background: rgba(171, 180, 244, 0.5);
  max-height: 25px;
  min-height: 25px;
  height: 25px;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-blue);

  position: relative;
  overflow: hidden;
`;

export const TotalDraftNumber = styled.span`
  margin-left: ${({ isLargeNumber }) => (isLargeNumber ? 31 : 21)}px;
`;

export const AdDraftPreviewNumber = styled.div`
  border-radius: 2px;
  display: flex;
  height: 21px;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  text-align: center;
  font-weight: 500;

  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-white);
  background: var(--primary-blue);
`;

export const AdDraftLabel = styled.div`
  font-weight: 500;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--primary-dark);
`;

export const CartNavigationWrapper = styled.div`
  display: grid;
  gap: 20px;
  justify-content: space-between;
  margin-top: ${({ mt }) => mt};
`;

export const CartSummary = styled.p`
  font-family: Rubik;
  font-size: var(--fs-lg);
  font-style: normal;
  font-weight: 600;
  line-height: var(--lh-lg);
  color: var(--primary-dark-300);
  width: 330px;
  > span {
    color: var(--primary-dark-600);
  }

  margin: 30px 0 20px;
`;
